module.exports = __webpack_public_path__ + "static/media/bus-stop.fbf7d083.svg";